module.exports = __webpack_public_path__ + "img/hepsijet.65fba0f1.png";